import React, { Suspense, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import 'bootstrap/dist/css/bootstrap.min.css'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import store, { persistor } from './redux/store'
import { CHOOSE_LANGUAGE } from './routes/routeConstant'
import { PostHogProvider } from 'posthog-js/react'
import { postHogOptions, REACT_APP_PUBLIC_POSTHOG_KEY } from './utils/config'
import { BrowserRouter } from 'react-router-dom'
import { checkOtpAuth } from 'utils/CheckAuthentication'
import { initI18n } from './i18n'

// Starts loading the interface strings before the first render.
initI18n()

const CheckAuthApp = () => {
  const { pathname } = window.location

  window.dataLayer.push({
    event: 'onboarding',
    page: {
      url: location,
      title: 'maayot • Your daily Chinese lesson',
    },
  })
  useEffect(() => {
    if (pathname.includes('integrations/beeminder') || pathname.includes(CHOOSE_LANGUAGE)) {
      console.log('return from check')
      return
    }
    checkOtpAuth()
  }, [])
  return <App />
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <PostHogProvider apiKey={REACT_APP_PUBLIC_POSTHOG_KEY || ''} options={postHogOptions}>
        <BrowserRouter>
          {/* Components using useTranslation suspend until their strings load, so no key ever flashes. */}
          <Suspense fallback={null}>
            <CheckAuthApp />
          </Suspense>
        </BrowserRouter>
      </PostHogProvider>
    </PersistGate>
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
